import * as React from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import Layout from "../components/Layout/Layout"
import Title from "../components/Title/Title"
import BreadcrumbBar from "../components/BreadcrumbBar/BreadcrumbBar"
import TxtImg from "../components/TxtImg/TxtImg"
import Testimonial from "../components/Testimonial/Testimonial"
import Team from "../components/Team/Team"

function About({ data }) {
    const parentPages = [{name: "Home", path: "/"}]
    const image = getImage(data.image)

    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="description" content="Desborough Osteopaths is run by Principal Osteopath Alex Hamilton, who has been practicing Osteopathy in Desborough for 20 years." />
                <title>About | Desborough Osteopaths</title>
                <html lang="en" />
            </Helmet>
            <Title title="About" />
            <BreadcrumbBar currentPage="About" parentPages={parentPages} />
            <section>
                <TxtImg imgSrc={image} imgAlt="">
                    <h3>Ut consectetur deserunt cillum incididunt laboris cupidatat veniam labore duis enim consequat consectetur.</h3>
                    <p>Esse Lorem consectetur aliqua elit enim laboris sit consectetur ullamco do. Ullamco velit ex et amet sunt non veniam commodo exercitation sit dolore laborum cupidatat. Voluptate sint deserunt quis veniam cupidatat adipisicing sit qui ea commodo nostrud officia ea. Id enim dolor labore deserunt sit esse laborum. Velit pariatur deserunt duis dolore labore aliqua ut deserunt in. Nisi mollit ad ullamco veniam sint culpa.</p>
                </TxtImg>
            </section>
            <section>
                <Testimonial quote="Veniam enim ipsum incididunt sit et esse nulla cillum cillum enim aute. Quis eiusmod veniam ipsum nisi consectetur cillum aute. Dolor magna irure tempor elit. Ea aliquip ex exercitation et labore qui elit laborum sunt consectetur enim." />
            </section>
            <section style={{backgroundColor: 'var(--neutral-100)'}}>
                <Team />
            </section>
        </Layout>
    )
}

export const query = graphql`
  query {
    image: file(relativePath: {eq: "hero-banner.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          width: 1000,
          placeholder: BLURRED,
          formats: WEBP
        )
      }
    }
  }
`

export default About